import { render, staticRenderFns } from "./ResumoOportunidadeCard.vue?vue&type=template&id=1e36ed73"
import script from "./ResumoOportunidadeCard.vue?vue&type=script&lang=js"
export * from "./ResumoOportunidadeCard.vue?vue&type=script&lang=js"
import style0 from "./ResumoOportunidadeCard.vue?vue&type=style&index=0&id=1e36ed73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports